import type { MisconceptionDefinition } from '../types'

/** REK — Context, strategie & algemene rekenfouten (slice 2). */
export const contextStrategieBasisMisconceptions: MisconceptionDefinition[] = [
  {
    id: 'rek.context-verkeerde-bewerking',
    label: 'Verkeerde bewerking bij verhaaltjessom',
    module: 'Basisrekenen',
    description:
      'Leerling kiest de verkeerde bewerking (bijv. optellen i.p.v. aftrekken) bij een contextvraag.',
    typicalFamilies: [
      'REK-CONTEXT-PLUS-MIN',
      'REK-CONTEXT-KEER-DEEL',
      'REK-CONTEXT-MEERSTAPS',
    ],
  },
  {
    id: 'rek.context-stap-vergeten',
    label: 'Stap vergeten bij meerstapsprobleem',
    module: 'Basisrekenen',
    description:
      'Leerling berekent slechts een deel van een meerstapsprobleem en vergeet de laatste stap.',
    typicalFamilies: ['REK-CONTEXT-PLUS-MIN', 'REK-CONTEXT-MEERSTAPS'],
  },
  {
    id: 'rek.verkeerd-afgerond',
    label: 'Verkeerd afgerond bij schatten',
    module: 'Basisrekenen',
    description:
      'Leerling rondt af naar een niet-dichtstbijzijnd getal bij het schatten.',
    typicalFamilies: [
      'REK-SCHATTEN',
      'REK-CONTEXT-KEER-DEEL',
      'REK-CONTEXT-MEERSTAPS',
    ],
  },
  {
    id: 'rek.strategie-verkeerde-correctie',
    label: 'Verkeerde correctie bij compenseren',
    module: 'Basisrekenen',
    description:
      'Leerling corrigeert de verkeerde kant op na compenseren (bijv. trekt af i.p.v. optellen).',
    typicalFamilies: ['REK-HANDIG-PLUS-MIN', 'REK-HANDIG-KEER'],
  },
  {
    id: 'rek.onvolledige-berekening',
    label: 'Onvolledige berekening',
    module: 'Basisrekenen',
    description:
      'Leerling stopt halverwege de berekening en geeft een tussenresultaat als eindantwoord.',
    typicalFamilies: [
      'REK-CONTEXT-PLUS-MIN',
      'REK-CONTEXT-KEER-DEEL',
      'REK-CONTEXT-MEERSTAPS',
      'REK-TAFELS-TOEPASSEN',
    ],
  },
  {
    id: 'rek.bewerking-verward',
    label: 'Bewerkingen verward',
    module: 'Basisrekenen',
    description:
      'Leerling verwart bewerkingen (bijv. vermenigvuldigt i.p.v. optellen, of deelt i.p.v. aftrekken).',
    typicalFamilies: [
      'REK-CONTEXT-KEER-DEEL',
      'REK-GEMENGD-BASIS',
      'REK-TAFELS-TOEPASSEN',
    ],
  },
  {
    id: 'rek.deler-deeltal-omgedraaid',
    label: 'Deler en deeltal omgedraaid',
    module: 'Basisrekenen',
    description:
      'Leerling draait deler en deeltal om (bv. leest 48 ÷ 6 als 6 ÷ 48, of berekent bij "verdeel 144 over 12 dozen" de deling 12 ÷ 144). Klassieke contextuele fout waarbij het kleinste getal automatisch als deler wordt aangenomen.',
    typicalFamilies: ['REK-CIJF-DEEL', 'REK-CONTEXT-KEER-DEEL'],
  },
  {
    id: 'rek.niet-handige-strategie',
    label: 'Kiest niet-handige strategie',
    module: 'Basisrekenen',
    description:
      'Leerling kiest een strategie die wel werkt maar niet handig is (bijv. cijferend i.p.v. factoren herkennen).',
    typicalFamilies: [
      'REK-HANDIG-KEER',
      'REK-HANDIG-DEEL',
      'REK-HANDIG-PLUS-MIN',
    ],
  },
  {
    id: 'rek.rekenfout',
    label: 'Rekenfout',
    module: 'Basisrekenen',
    description:
      'Leerling maakt een rekenfout bij vermenigvuldigen, delen of een tussenstap (niet gerelateerd aan een specifieke misconceptie).',
    typicalFamilies: [
      'REK-CONTEXT-KEER-DEEL',
      'REK-HANDIG-KEER',
      'REK-HANDIG-DEEL',
      'REK-GEMENGD-TOETS',
    ],
  },
  {
    id: 'rek.context-verkeerde-gegevens',
    label: 'Verkeerde gegevens uit context gehaald',
    module: 'Basisrekenen',
    description:
      'Leerling gebruikt een verkeerd getal uit de opgave: pakt het verkeerde tarief, het verkeerde aantal of de verkeerde deler. De bewerking klopt vaak wel, maar de invoer is fout (bv. deelt door 20 i.p.v. 18, of gebruikt 4 i.p.v. 5 rondjes).',
    typicalFamilies: [
      'REK-CONTEXT-KEER-DEEL',
      'REK-CONTEXT-MEERSTAPS',
      'REK-HANDIG-KEER',
      'REK-HANDIG-DEEL',
      'REK-HANDIG-PLUS-MIN',
      'REK-TAFELS-UITBREIDEN',
      'REK-GEMENGD-TOETS',
    ],
  },
]
